import request from '../utils/request'

const authService = {
  // 登录
  login: (data) => {
    return request({
      url: '/auth/login',
      method: 'post',
      data
    })
  },

  // 获取当前用户权限
  getPermissionsByRoles: (data) => {
    return request({
      url: '/auth/permissions',
      method: 'post',
      data
    })
  },

  // 获取用户信息
  getUserInfo: () => {
    return request({
      url: '/auth/current-user',
      method: 'post'
    })
  },

}

export default authService
